import i18n, { ParseKeys } from 'i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import enClient from './locales/en/client.json'
import enOffice from './locales/en/office.json'
import heClient from './locales/he/client.json'
import heOffice from './locales/he/office.json'

export type TransKey = ParseKeys
export type AppLanguage = 'he' | 'en'
export const defaultNS = 'translation' as const

const en = { ...enClient, ...enOffice }
const he = { ...heClient, ...heOffice }

export const resources = {
  en: { translation: en },
  he: { translation: he },
} as const

/** Persisted office UI language. Forced route languages must not write here. */
const STORAGE_KEY = 'i18nextLng'

export function getStoredLanguage(): AppLanguage | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'en' || stored === 'he') return stored
  } catch {
    // ignore
  }
  return null
}

export function getPreferredLanguage(): AppLanguage {
  return getStoredLanguage() ?? 'he'
}

/** Warehouse-only staff abroad default to English until they pick a language. */
export function getOfficeLanguage(user: { permissions?: Partial<Record<string, boolean>> } | null | undefined): AppLanguage {
  const stored = getStoredLanguage()
  if (stored) return stored
  const permissions = user?.permissions
  const isWarehouseStaff = !!permissions?.Worker || !!permissions?.OfficeManager
  const isAgentLike = !!permissions?.Admin || !!permissions?.SeniorAgent || !!permissions?.Agent
  if (isWarehouseStaff && !isAgentLike) return 'en'
  return 'he'
}

export function setPreferredLanguage(lang: AppLanguage): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang)
  } catch {
    // ignore
  }
}

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS,
    lng: getPreferredLanguage(),
    fallbackLng: 'he',
    supportedLngs: ['he', 'en'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b'],
    },
  })

export default i18n
